// src/pages/Detail.jsx
import React, { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AppContext from '../contexts/AppContext';
import { Carousel } from 'react-responsive-carousel';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import PdfViewer from '../components/PdfViewer.js';
import { sanitizeAndParseHtml } from '../utils/HtmlParser';
import { resolveIconUrl } from '../utils/IconSource.js';

const Detail = () => {
  const { id } = useParams();
  const { contentInfo, hotelInfo, theme, venueId } = useContext(AppContext);
  const [detail, setDetail] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const findNodeById = (tid, node) => {
      const queue = [node];
      while (queue.length > 0) {
        const currentNode = queue.shift();
        if (currentNode.id === tid) return currentNode;
        if (currentNode.attributes) {
          queue.push(...currentNode.attributes);
        }
      }
      return null;
    };
    if (id && contentInfo) {
      const node = findNodeById(id, contentInfo)
      setDetail(node)
    }
  }, [contentInfo, id])

  useEffect(() => {
    if (detail?.externalUrl?.name === 'External' && detail.externalUrl.url) {
      window.location.replace(detail.externalUrl.url);
    }
  }, [detail]); 
  
  const urlRegex = /https?:\/\/[^\s]+/i;
  // 先判断 detail.searchTags 是否为字符串
  let matchedLink = null;
  if (typeof detail?.searchTags === "string") {
    // exec 或 match 都可以
    const match = detail.searchTags.match(urlRegex);
    if (match) {
      matchedLink = match[0]; // 第一个匹配到的链接
    }
  }

  if (!hotelInfo) { return <div>Loading...</div>; }

  const servicesHeader = (theme?.color || theme?.secondaryColor) ? 'rgb(0,0,0)' : (theme?.servicesHeader || 'rgb(0,0,0)');
  const servicesBackground = (theme?.color || theme?.secondaryColor) ? "rgb(255,255,255)" : theme?.servicesBackground || 'rgb(255,255,255)';


  // 如果 detail.externalUrl 存在，则直接渲染 PdfViewer
  if (detail && detail.externalUrl) {
    if (detail.externalUrl.name === 'PDF') {
      return <PdfViewer src={detail.externalUrl.url} />;
    } else if (detail.externalUrl.name === 'External') {
      return null;
    }
  }

const detailIconSrc = resolveIconUrl(detail?.iconImage);
  return (
    <div className="flex-1" style={{ backgroundColor: servicesBackground }}>
      {detail && detail.isLeaf && <div >
        {detail && detail.carouselImages && detail.carouselImages.length > 0 && (
          detail.carouselImages.length <= 1 ?
            <img src={detail.carouselImages[0]} alt='homeImage' className='object-cover w-full h-[56.25vw] xs:max-w-md xs:max-h-64' />
            :
            <Carousel
              showArrows={true}
              showThumbs={false}
              infiniteLoop={true}
              autoPlay={true}
              showIndicators={false}
              showStatus={false}
              className="w-full h-full"
            >
              {detail.carouselImages.map((url, index) => (
                <div key={index} className="w-full h-full">
                  <img
                    src={url}
                    alt={`Home Adv ${index + 1}`}
                    className="object-cover w-full h-[56.25vw] xs:max-w-md xs:max-h-64"
                  />
                </div>
              ))}
            </Carousel>)}
        <div className='flex justify-between px-8 py-4'>
          {detailIconSrc ?
            <img src={detailIconSrc} className='object-cover rounded-lg w-6 h-6 ' alt="icon" />
            :
            <p>&nbsp;</p>}
          <ArrowLeftIcon className='w-6 h-6' style={{ color: servicesHeader }} onClick={() => { navigate(-1) }} />
        </div>
        <div className='px-8 text-2xl font-semibold' style={{ color: servicesHeader }}>
          {detail.name}
        </div>
        {matchedLink && (
          <div className="px-8 py-3 flex justify-center">
            <button
              className="px-4 py-2 rounded text-white" style={{ backgroundColor: servicesHeader }}
              onClick={() => window.open(matchedLink, '_blank')}
            >
              Order Now
            </button>
          </div>
        )}
        <div className='content-body px-4 py-3 text-sm'>
          {sanitizeAndParseHtml(detail.mainText || '', venueId)}
        </div>
      </div>}

    </div>
  );
};

export default Detail;
